import React, { useState } from 'react';

function CadastroFatura() {
  const [fatura, setFatura] = useState({
    cliente_nome: '',
    cliente_endereco: '',
    cliente_nif: '',
    produtos: [
      {
        codigo: '',
        descricao: '',
        quantidade: 1,
        unidade: 'UND',
        preco_unitario: 0,
        desconto: 0
      }
    ]
  });

  const handleChange = (e) => {
    setFatura({ ...fatura, [e.target.name]: e.target.value });
  };

  const handleProdutoChange = (index, e) => {
    const updatedProdutos = [...fatura.produtos];
    updatedProdutos[index][e.target.name] = e.target.value;
    setFatura({ ...fatura, produtos: updatedProdutos });
  };

  const addProduto = () => {
    setFatura({
      ...fatura,
      produtos: [
        ...fatura.produtos,
        {
          codigo: '',
          descricao: '',
          quantidade: 1,
          unidade: 'UND',
          preco_unitario: 0,
          desconto: 0
        }
      ]
    });
  };

  const removeProduto = (index) => {
    const updatedProdutos = fatura.produtos.filter((_, i) => i !== index);
    setFatura({ ...fatura, produtos: updatedProdutos });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch('http://localhost:8000/api/faturas/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(fatura)
    });

    if (response.ok) {
      alert('Fatura cadastrada com sucesso!');
      // opcional: limpar formulário após sucesso
      setFatura({
        cliente_nome: '',
        cliente_endereco: '',
        cliente_nif: '',
        produtos: [
          {
            codigo: '',
            descricao: '',
            quantidade: 1,
            unidade: 'UND',
            preco_unitario: 0,
            desconto: 0
          }
        ]
      });
    } else {
      alert('Erro ao cadastrar fatura.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Cadastro de Fatura</h2>
      {/* REMOVIDOS número e datas */}
      <input
        name="cliente_nome"
        placeholder="Nome do Cliente"
        value={fatura.cliente_nome}
        onChange={handleChange}
        required
      />
      <input
        name="cliente_endereco"
        placeholder="Endereço"
        value={fatura.cliente_endereco}
        onChange={handleChange}
        required
      />
      <input
        name="cliente_nif"
        placeholder="NIF"
        value={fatura.cliente_nif}
        onChange={handleChange}
        required
      />

      <h3>Produtos</h3>
      {fatura.produtos.map((produto, index) => (
        <div
          key={index}
          style={{ marginBottom: '10px', border: '1px solid #ccc', padding: '10px' }}
        >
          <input
            name="codigo"
            placeholder="Código"
            value={produto.codigo}
            onChange={(e) => handleProdutoChange(index, e)}
            required
          />
          <input
            name="descricao"
            placeholder="Descrição"
            value={produto.descricao}
            onChange={(e) => handleProdutoChange(index, e)}
            required
          />
          <input
            name="quantidade"
            type="number"
            min="1"
            placeholder="Qtd"
            value={produto.quantidade}
            onChange={(e) => handleProdutoChange(index, e)}
            required
          />
          <input
            name="unidade"
            placeholder="Unidade"
            value={produto.unidade}
            onChange={(e) => handleProdutoChange(index, e)}
            required
          />
          <input
            name="preco_unitario"
            type="number"
            min="0"
            step="0.01"
            placeholder="Preço"
            value={produto.preco_unitario}
            onChange={(e) => handleProdutoChange(index, e)}
            required
          />
          <input
            name="desconto"
            type="number"
            min="0"
            max="100"
            placeholder="Desconto (%)"
            value={produto.desconto}
            onChange={(e) => handleProdutoChange(index, e)}
          />
          <button type="button" onClick={() => removeProduto(index)}>
            Remover
          </button>
        </div>
      ))}
      <button type="button" onClick={addProduto}>
        Adicionar Produto
      </button>
      <br />
      <br />
      <button type="submit">Salvar Fatura</button>
    </form>
  );
}

export default CadastroFatura;
